export default __webpack_public_path__ + "images/daeefaecad7e2084f7ecd955232543e3.svg";